import { useCallback } from 'react';

import { Checkbox } from '../../../../../../../../../helpers/Checkbox';

interface ThreeDStockProductsFiltersCollectionsFilterItemCollection {
  id: string;
  name: string;
}

interface ThreeDStockProductsFiltersCollectionsFilterItemProps {
  collection: ThreeDStockProductsFiltersCollectionsFilterItemCollection;
  onCheckedCollection: (collectionId: string, checked: boolean) => void;
  checked: boolean;
}

function ThreeDStockProductsFiltersCollectionsFilterItem({
  onCheckedCollection,
  collection,
  checked
}: ThreeDStockProductsFiltersCollectionsFilterItemProps) {
  const handleCheck = useCallback(
    (checked: boolean) => {
      onCheckedCollection(collection.id, checked);
    },
    [onCheckedCollection, collection]
  );

  return (
    <li className="py-1">
      <Checkbox
        dataGa={`collection-${collection?.name}`}
        checkboxWrapperClassName="flex items-center"
        label={collection?.name}
        checked={checked}
        onChange={handleCheck}
      />
    </li>
  );
}

export default ThreeDStockProductsFiltersCollectionsFilterItem;
